import {CelestialBodyType, CelestialBody} from '../scene.model';

export const S_2009_S_1: CelestialBody = {
  id: 's_2009-s-1',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0001e15,
  radius: 0.15,
  semiMajorAxis: 117000,
  eccentricity: 0,
  trueAnomaly: 0,
  meanAnomaly: 0,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PAN: CelestialBody = {
  id: 'pan',
  position: {
    x: 0,
    y: 0
  },
  mass: 4.95e15,
  radius: 14.1,
  semiMajorAxis: 133584,
  eccentricity: 0,
  trueAnomaly: 0,
  meanAnomaly: 351.187,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const DAPHNIS: CelestialBody = {
  id: 'daphnis',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.084e15,
  radius: 3.8,
  semiMajorAxis: 136505,
  eccentricity: 0,
  trueAnomaly: 0,
  meanAnomaly: 113.790,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ATLAS: CelestialBody = {
  id: 'atlas',
  position: {
    x: 0,
    y: 0
  },
  mass: 6.6e15,
  radius: 15.1,
  semiMajorAxis: 137670,
  eccentricity: 0.0012,
  trueAnomaly: 0,
  meanAnomaly: 283.282,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PROMETHEUS: CelestialBody = {
  id: 'prometheus',
  position: {
    x: 0,
    y: 0
  },
  mass: 159.5e15,
  radius: 43.1,
  semiMajorAxis: 139380,
  eccentricity: 0.0022,
  trueAnomaly: 0,
  meanAnomaly: 96.886,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PANDORA: CelestialBody = {
  id: 'pandora',
  position: {
    x: 0,
    y: 0
  },
  mass: 137.1e15,
  radius: 40.7,
  semiMajorAxis: 141720,
  eccentricity: 0.0042,
  trueAnomaly: 0,
  meanAnomaly: 125.112,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const EPIMETHEUS: CelestialBody = {
  id: 'epimetheus',
  position: {
    x: 0,
    y: 0
  },
  mass: 526.6e15,
  radius: 58.1,
  semiMajorAxis: 151422,
  eccentricity: 0.0098,
  trueAnomaly: 0,
  meanAnomaly: 80.377,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const JANUS: CelestialBody = {
  id: 'janus',
  position: {
    x: 0,
    y: 0
  },
  mass: 1897.5e15,
  radius: 89.5,
  semiMajorAxis: 151472,
  eccentricity: 0.0068,
  trueAnomaly: 0,
  meanAnomaly: 17.342,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const AEGAEON: CelestialBody = {
  id: 'aegaeon',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0001e15,
  radius: 0.33,
  semiMajorAxis: 167500,
  eccentricity: 0.0004,
  trueAnomaly: 0,
  meanAnomaly: 322.771,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const MIMAS: CelestialBody = {
  id: 'mimas',
  position: {
    x: 0,
    y: 0
  },
  mass: 37493e15,
  radius: 198.2,
  semiMajorAxis: 185404,
  eccentricity: 0.0202,
  trueAnomaly: 0,
  meanAnomaly: 14.848,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const METHONE: CelestialBody = {
  id: 'methone',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.02e15,
  radius: 1.45,
  semiMajorAxis: 194440,
  eccentricity: 0.0001,
  trueAnomaly: 0,
  meanAnomaly: 71.189,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ANTHE: CelestialBody = {
  id: 'anthe',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e15,
  radius: 0.9,
  semiMajorAxis: 197700,
  eccentricity: 0.0011,
  trueAnomaly: 0,
  meanAnomaly: 190.473,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PALLENE: CelestialBody = {
  id: 'pallene',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2.22,
  semiMajorAxis: 212280,
  eccentricity: 0.004,
  trueAnomaly: 0,
  meanAnomaly: 356.229,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ENCELADUS: CelestialBody = {
  id: 'enceladus',
  position: {
    x: 0,
    y: 0
  },
  mass: 108022e15,
  radius: 252.1,
  semiMajorAxis: 237950,
  eccentricity: 0.0047,
  trueAnomaly: 0,
  meanAnomaly: 199.686,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TETHYS: CelestialBody = {
  id: 'tethys',
  position: {
    x: 0,
    y: 0
  },
  mass: 617449e15,
  radius: 531.1,
  semiMajorAxis: 294619,
  eccentricity: 0.0001,
  trueAnomaly: 0,
  meanAnomaly: 243.367,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TELESTO: CelestialBody = {
  id: 'telesto',
  position: {
    x: 0,
    y: 0
  },
  mass: 9.41e15,
  radius: 12.4,
  semiMajorAxis: 294619,
  eccentricity: 0,
  trueAnomaly: 0,
  meanAnomaly: 260.157,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CALYPSO: CelestialBody = {
  id: 'calypso',
  position: {
    x: 0,
    y: 0
  },
  mass: 6.3e15,
  radius: 10.7,
  semiMajorAxis: 294619,
  eccentricity: 0,
  trueAnomaly: 0,
  meanAnomaly: 156.660,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const DIONE: CelestialBody = {
  id: 'dione',
  position: {
    x: 0,
    y: 0
  },
  mass: 1095452e15,
  radius: 561.4,
  semiMajorAxis: 377396,
  eccentricity: 0.0022,
  trueAnomaly: 0,
  meanAnomaly: 322.232,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HELENE: CelestialBody = {
  id: 'helene',
  position: {
    x: 0,
    y: 0
  },
  mass: 24.5e15,
  radius: 17.6,
  semiMajorAxis: 377396,
  eccentricity: 0.0022,
  trueAnomaly: 0,
  meanAnomaly: 43.186,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const POLYDEUCES: CelestialBody = {
  id: 'polydeuces',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.03e15,
  radius: 1.3,
  semiMajorAxis: 377396,
  eccentricity: 0.0192,
  trueAnomaly: 0,
  meanAnomaly: 89.307,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const RHEA: CelestialBody = {
  id: 'rhea',
  position: {
    x: 0,
    y: 0
  },
  mass: 2306518e15,
  radius: 763.8,
  semiMajorAxis: 527108,
  eccentricity: 0.0013,
  trueAnomaly: 0,
  meanAnomaly: 179.781,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TITAN: CelestialBody = {
  id: 'titan',
  position: {
    x: 0,
    y: 0
  },
  mass: 134520000e15,
  radius: 2574.73,
  semiMajorAxis: 1221930,
  eccentricity: 0.0288,
  trueAnomaly: 0,
  meanAnomaly: 163.310,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HYPERION: CelestialBody = {
  id: 'hyperion',
  position: {
    x: 0,
    y: 0
  },
  mass: 5619.9e15,
  radius: 135,
  semiMajorAxis: 1481010,
  eccentricity: 0.123,
  trueAnomaly: 0,
  meanAnomaly: 86.342,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const IAPETUS: CelestialBody = {
  id: 'iapetus',
  position: {
    x: 0,
    y: 0
  },
  mass: 1805635e15,
  radius: 734.3,
  semiMajorAxis: 3560820,
  eccentricity: 0.0286,
  trueAnomaly: 0,
  meanAnomaly: 201.789,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const KIVIUQ: CelestialBody = {
  id: 'kiviuq',
  position: {
    x: 0,
    y: 0
  },
  mass: 2.79e15,
  radius: 8.5,
  semiMajorAxis: 11307500,
  eccentricity: 0.1521,
  trueAnomaly: 0,
  meanAnomaly: 172.018,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const IJIRAQ: CelestialBody = {
  id: 'ijiraq',
  position: {
    x: 0,
    y: 0
  },
  mass: 1.18e15,
  radius: 6.5,
  semiMajorAxis: 11348500,
  eccentricity: 0.3758,
  trueAnomaly: 0,
  meanAnomaly: 17.328,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PHOEBE: CelestialBody = {
  id: 'phoebe',
  position: {
    x: 0,
    y: 0
  },
  mass: 8292e15,
  radius: 106.5,
  semiMajorAxis: 12905900,
  eccentricity: 0.1604,
  trueAnomaly: 0,
  meanAnomaly: 53.038,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PAALIAQ: CelestialBody = {
  id: 'paaliaq',
  position: {
    x: 0,
    y: 0
  },
  mass: 7.25e15,
  radius: 12.5,
  semiMajorAxis: 15012800,
  eccentricity: 0.4826,
  trueAnomaly: 0,
  meanAnomaly: 321.654,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SKATHI: CelestialBody = {
  id: 'skathi',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.35e15,
  radius: 4,
  semiMajorAxis: 15563600,
  eccentricity: 0.2755,
  trueAnomaly: 0,
  meanAnomaly: 114.689,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_37: CelestialBody = {
  id: 's_2004-s-37',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 15822400,
  eccentricity: 0.5265,
  trueAnomaly: 0,
  meanAnomaly: 326.7,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2007_S_2: CelestialBody = {
  id: 's_2007-s-2',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 15971500,
  eccentricity: 0.2465,
  trueAnomaly: 0,
  meanAnomaly: 84.066,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ALBIORIX: CelestialBody = {
  id: 'albiorix',
  position: {
    x: 0,
    y: 0
  },
  mass: 22.3e15,
  radius: 14.3,
  semiMajorAxis: 16222700,
  eccentricity: 0.5807,
  trueAnomaly: 0,
  meanAnomaly: 32.828,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const BEBHIONN: CelestialBody = {
  id: 'bebhionn',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 16900900,
  eccentricity: 0.3813,
  trueAnomaly: 0,
  meanAnomaly: 168.045,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_29: CelestialBody = {
  id: 's_2004-s-29',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 17202800,
  eccentricity: 0.4269,
  trueAnomaly: 0,
  meanAnomaly: 211.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SKOLL: CelestialBody = {
  id: 'skoll',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 2.5,
  semiMajorAxis: 17438300,
  eccentricity: 0.4402,
  trueAnomaly: 0,
  meanAnomaly: 44.965,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_31: CelestialBody = {
  id: 's_2004-s-31',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 17449700,
  eccentricity: 0.2525,
  trueAnomaly: 0,
  meanAnomaly: 275.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ERRIAPUS: CelestialBody = {
  id: 'erriapus',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.68e15,
  radius: 5,
  semiMajorAxis: 17705500,
  eccentricity: 0.452,
  trueAnomaly: 0,
  meanAnomaly: 294.829,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TARQEQ: CelestialBody = {
  id: 'tarqeq',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.23e15,
  radius: 3.5,
  semiMajorAxis: 17724200,
  eccentricity: 0.1373,
  trueAnomaly: 0,
  meanAnomaly: 161.020,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SIARNAQ: CelestialBody = {
  id: 'siarnaq',
  position: {
    x: 0,
    y: 0
  },
  mass: 43.5e15,
  radius: 19.65,
  semiMajorAxis: 17937000,
  eccentricity: 0.5293,
  trueAnomaly: 0,
  meanAnomaly: 201.288,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TARVOS: CelestialBody = {
  id: 'tarvos',
  position: {
    x: 0,
    y: 0
  },
  mass: 2.3e15,
  radius: 7.5,
  semiMajorAxis: 18243800,
  eccentricity: 0.4799,
  trueAnomaly: 0,
  meanAnomaly: 265.783,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HYRROKKIN: CelestialBody = {
  id: 'hyrrokkin',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.35e15,
  radius: 4,
  semiMajorAxis: 18348800,
  eccentricity: 0.3582,
  trueAnomaly: 0,
  meanAnomaly: 291.841,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const GREIP: CelestialBody = {
  id: 'greip',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 2.5,
  semiMajorAxis: 18379000,
  eccentricity: 0.3331,
  trueAnomaly: 0,
  meanAnomaly: 314.541,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const MUNDILFARI: CelestialBody = {
  id: 'mundilfari',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.23e15,
  radius: 3.5,
  semiMajorAxis: 18470800,
  eccentricity: 0.1787,
  trueAnomaly: 0,
  meanAnomaly: 92.821,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_13: CelestialBody = {
  id: 's_2004-s-13',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 18594700,
  eccentricity: 0.29,
  trueAnomaly: 0,
  meanAnomaly: 41.077,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2006_S_1: CelestialBody = {
  id: 's_2006-s-1',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 2.5,
  semiMajorAxis: 18839700,
  eccentricity: 0.0972,
  trueAnomaly: 0,
  meanAnomaly: 96.596,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2007_S_3: CelestialBody = {
  id: 's_2007-s-3',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.09e15,
  radius: 2.5,
  semiMajorAxis: 19143500,
  eccentricity: 0.1671,
  trueAnomaly: 0,
  meanAnomaly: 292.691,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SUTTUNGR: CelestialBody = {
  id: 'suttungr',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.23e15,
  radius: 3.5,
  semiMajorAxis: 19166800,
  eccentricity: 0.1445,
  trueAnomaly: 0,
  meanAnomaly: 321.133,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_20: CelestialBody = {
  id: 's_2004-s-20',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 19188100,
  eccentricity: 0.1976,
  trueAnomaly: 0,
  meanAnomaly: 341.3,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const JARNSAXA: CelestialBody = {
  id: 'jarnsaxa',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 19197900,
  eccentricity: 0.2148,
  trueAnomaly: 0,
  meanAnomaly: 198.750,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const NARVI: CelestialBody = {
  id: 'narvi',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.23e15,
  radius: 3.5,
  semiMajorAxis: 19226600,
  eccentricity: 0.299,
  trueAnomaly: 0,
  meanAnomaly: 114.172,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const BERGELMIR: CelestialBody = {
  id: 'bergelmir',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 2.5,
  semiMajorAxis: 19290200,
  eccentricity: 0.1399,
  trueAnomaly: 0,
  meanAnomaly: 306.494,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HATI: CelestialBody = {
  id: 'hati',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 2.5,
  semiMajorAxis: 19435300,
  eccentricity: 0.3295,
  trueAnomaly: 0,
  meanAnomaly: 163.640,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_17: CelestialBody = {
  id: 's_2004-s-17',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 19574300,
  eccentricity: 0.1916,
  trueAnomaly: 0,
  meanAnomaly: 228.545,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_12: CelestialBody = {
  id: 's_2004-s-12',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.09e15,
  radius: 2.5,
  semiMajorAxis: 19736400,
  eccentricity: 0.3929,
  trueAnomaly: 0,
  meanAnomaly: 1.599,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_27: CelestialBody = {
  id: 's_2004-s-27',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 19982800,
  eccentricity: 0.1364,
  trueAnomaly: 0,
  meanAnomaly: 92.56,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const FARBAUTI: CelestialBody = {
  id: 'farbauti',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.09e15,
  radius: 2.5,
  semiMajorAxis: 20101600,
  eccentricity: 0.1756,
  trueAnomaly: 0,
  meanAnomaly: 282.813,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const THRYMR: CelestialBody = {
  id: 'thrymr',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.23e15,
  radius: 4,
  semiMajorAxis: 20236700,
  eccentricity: 0.4332,
  trueAnomaly: 0,
  meanAnomaly: 30.075,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const BESTLA: CelestialBody = {
  id: 'bestla',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.23e15,
  radius: 3.5,
  semiMajorAxis: 20432100,
  eccentricity: 0.7072,
  trueAnomaly: 0,
  meanAnomaly: 239.156,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_7: CelestialBody = {
  id: 's_2004-s-7',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 20576700,
  eccentricity: 0.4998,
  trueAnomaly: 0,
  meanAnomaly: 79.762,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const AEGIR: CelestialBody = {
  id: 'aegir',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 20598900,
  eccentricity: 0.2379,
  trueAnomaly: 0,
  meanAnomaly: 26.017,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_30: CelestialBody = {
  id: 's_2004-s-30',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.03e15,
  radius: 1.5,
  semiMajorAxis: 20733300,
  eccentricity: 0.0859,
  trueAnomaly: 0,
  meanAnomaly: 132.4,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_22: CelestialBody = {
  id: 's_2004-s-22',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.03e15,
  radius: 1.5,
  semiMajorAxis: 20737100,
  eccentricity: 0.2369,
  trueAnomaly: 0,
  meanAnomaly: 118.0,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_25: CelestialBody = {
  id: 's_2004-s-25',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 20814800,
  eccentricity: 0.4362,
  trueAnomaly: 0,
  meanAnomaly: 301.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_32: CelestialBody = {
  id: 's_2004-s-32',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 20963400,
  eccentricity: 0.2594,
  trueAnomaly: 0,
  meanAnomaly: 298.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_23: CelestialBody = {
  id: 's_2004-s-23',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 21444300,
  eccentricity: 0.4133,
  trueAnomaly: 0,
  meanAnomaly: 357.2,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2006_S_3: CelestialBody = {
  id: 's_2006-s-3',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 21607300,
  eccentricity: 0.4533,
  trueAnomaly: 0,
  meanAnomaly: 167.147,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_35: CelestialBody = {
  id: 's_2004-s-35',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 21864500,
  eccentricity: 0.203,
  trueAnomaly: 0,
  meanAnomaly: 231.7,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const KARI: CelestialBody = {
  id: 'kari',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.23e15,
  radius: 3,
  semiMajorAxis: 21988000,
  eccentricity: 0.3745,
  trueAnomaly: 0,
  meanAnomaly: 286.021,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_28: CelestialBody = {
  id: 's_2004-s-28',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 22134400,
  eccentricity: 0.1249,
  trueAnomaly: 0,
  meanAnomaly: 26.40,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const LOGE: CelestialBody = {
  id: 'loge',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 2.5,
  semiMajorAxis: 22563800,
  eccentricity: 0.1584,
  trueAnomaly: 0,
  meanAnomaly: 337.237,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_38: CelestialBody = {
  id: 's_2004-s-38',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 22616000,
  eccentricity: 0.4084,
  trueAnomaly: 0,
  meanAnomaly: 134.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const FENRIR: CelestialBody = {
  id: 'fenrir',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 22753400,
  eccentricity: 0.0949,
  trueAnomaly: 0,
  meanAnomaly: 131.678,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const YMIR: CelestialBody = {
  id: 'ymir',
  position: {
    x: 0,
    y: 0
  },
  mass: 3.97e15,
  radius: 9.5,
  semiMajorAxis: 22841900,
  eccentricity: 0.3431,
  trueAnomaly: 0,
  meanAnomaly: 228.673,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SURTUR: CelestialBody = {
  id: 'surtur',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 23065900,
  eccentricity: 0.3591,
  trueAnomaly: 0,
  meanAnomaly: 136.191,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_33: CelestialBody = {
  id: 's_2004-s-33',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 23087600,
  eccentricity: 0.4113,
  trueAnomaly: 0,
  meanAnomaly: 84.64,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_24: CelestialBody = {
  id: 's_2004-s-24',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.03e15,
  radius: 1.5,
  semiMajorAxis: 23326300,
  eccentricity: 0.04,
  trueAnomaly: 0,
  meanAnomaly: 162.7,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_21: CelestialBody = {
  id: 's_2004-s-21',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.03e15,
  radius: 1.5,
  semiMajorAxis: 23356200,
  eccentricity: 0.3156,
  trueAnomaly: 0,
  meanAnomaly: 136.2,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_39: CelestialBody = {
  id: 's_2004-s-39',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.03e15,
  radius: 1.5,
  semiMajorAxis: 23463800,
  eccentricity: 0.0979,
  trueAnomaly: 0,
  meanAnomaly: 114.7,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_36: CelestialBody = {
  id: 's_2004-s-36',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.03e15,
  radius: 1.5,
  semiMajorAxis: 23576500,
  eccentricity: 0.7139,
  trueAnomaly: 0,
  meanAnomaly: 32.50,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const FORNJOT: CelestialBody = {
  id: 'fornjot',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.15e15,
  radius: 3,
  semiMajorAxis: 24451700,
  eccentricity: 0.1613,
  trueAnomaly: 0,
  meanAnomaly: 214.499,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_34: CelestialBody = {
  id: 's_2004-s-34',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.03e15,
  radius: 1.5,
  semiMajorAxis: 24865000,
  eccentricity: 0.2015,
  trueAnomaly: 0,
  meanAnomaly: 314.4,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2004_S_26: CelestialBody = {
  id: 's_2004-s-26',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.05e15,
  radius: 2,
  semiMajorAxis: 26701600,
  eccentricity: 0.1726,
  trueAnomaly: 0,
  meanAnomaly: 306.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2019_S_1: CelestialBody = {
  id: 's_2019-s-1',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.014e15,
  radius: 1.5,
  semiMajorAxis: 11244000,
  eccentricity: 0.541,
  trueAnomaly: 0,
  meanAnomaly: 66.33,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SATURN: CelestialBody = {
  id: 'saturn',
  position: {
    x: 0,
    y: 0
  },
  speed: 9.68,
  mass: 5.6834e26,
  radius: 58232,
  semiMajorAxis: 1433530000,
  eccentricity: 0.0565,
  trueAnomaly: 0,
  meanAnomaly: 317.020,
  longitudeOfAscendingNode: 113.665,
  type: CelestialBodyType.PLANET,
  satellites: [
    S_2009_S_1,
    PAN,
    DAPHNIS,
    ATLAS,
    PROMETHEUS,
    PANDORA,
    EPIMETHEUS,
    JANUS,
    AEGAEON,
    MIMAS,
    METHONE,
    ANTHE,
    PALLENE,
    ENCELADUS,
    TETHYS,
    TELESTO,
    CALYPSO,
    DIONE,
    HELENE,
    POLYDEUCES,
    RHEA,
    TITAN,
    HYPERION,
    IAPETUS,
    KIVIUQ,
    IJIRAQ,
    PHOEBE,
    PAALIAQ,
    SKATHI,
    S_2004_S_37,
    S_2007_S_2,
    ALBIORIX,
    BEBHIONN,
    S_2004_S_29,
    SKOLL,
    S_2004_S_31,
    ERRIAPUS,
    TARQEQ,
    SIARNAQ,
    TARVOS,
    HYRROKKIN,
    GREIP,
    MUNDILFARI,
    S_2004_S_13,
    S_2006_S_1,
    S_2007_S_3,
    SUTTUNGR,
    S_2004_S_20,
    JARNSAXA,
    NARVI,
    BERGELMIR,
    HATI,
    S_2004_S_17,
    S_2004_S_12,
    S_2004_S_27,
    FARBAUTI,
    THRYMR,
    BESTLA,
    S_2004_S_7,
    AEGIR,
    S_2004_S_30,
    S_2004_S_22,
    S_2004_S_25,
    S_2004_S_32,
    S_2004_S_23,
    S_2006_S_3,
    S_2004_S_35,
    KARI,
    S_2004_S_28,
    LOGE,
    S_2004_S_38,
    FENRIR,
    YMIR,
    SURTUR,
    S_2004_S_33,
    S_2004_S_24,
    S_2004_S_21,
    S_2004_S_39,
    S_2004_S_36,
    FORNJOT,
    S_2004_S_34,
    S_2004_S_26,
    S_2019_S_1
  ],
  rings: [
    { id: 'a', radius: 122170, width: 14600, depth: 10 },
    { id: 'b', radius: 92000, width: 25500, depth: 5 },
    { id: 'c', radius: 74658, width: 17500, depth: 5 },
    { id: 'd', radius: 66900, width: 7500, depth: 5 },
    { id: 'f', radius: 140180, width: 500, depth: 5 },
    { id: 'g', radius: 166000, width: 9000, depth: 5 },
    { id: 'e', radius: 180000, width: 300000, depth: 5 }
  ],
  orbitBody: null
};

SATURN.satellites.forEach(satellite => satellite.orbitBody = SATURN);
